var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashColorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.75,
    height: 35,
    viewBox: "0 0 43.75 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash",
    transform: "translate(-238 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 43.75,
    height: 35,
    transform: "translate(238 8)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "trash-2",
    "data-name": "trash",
    d: "M3.125,16.312A1.687,1.687,0,0,0,4.812,18h8.125a1.688,1.688,0,0,0,1.688-1.687l1-11.812H2.125Zm9.062-9a.562.562,0,0,1,1.125,0l-.5,7.875a.563.563,0,0,1-1.125,0Zm-3.875,0a.562.562,0,0,1,1.125,0v7.875a.562.562,0,1,1-1.125,0Zm-3.875,0a.562.562,0,0,1,1.125,0l.5,7.875a.562.562,0,1,1-1.125,0Zm10.25-6.187H11.969l-.33-.657A.844.844,0,0,0,10.882,0H6.864a.834.834,0,0,0-.752.468l-.33.657H3.062c-.311,0-.562.252-1.062,1.687a.563.563,0,0,0,.563.562H15.187a.562.562,0,0,0,.563-.562C15.25,1.377,15,1.125,14.687,1.125Z",
    transform: "translate(251 16.5)",
    fill: "#c21618"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashColorRed);
export default __webpack_public_path__ + "static/media/TrashColorRed.319e7b82b66e7c022c2911656b172855.svg";
export { ForwardRef as ReactComponent };